const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes";
const $ba30e20475feac5a$export$196440f71ed9f601 = 10;
const $ba30e20475feac5a$export$7167c830cefcb6b5 = "9b94c43e-e561-40c7-b94e-9c8c493ac181";



const $d3824bf2ef2465db$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $d3824bf2ef2465db$export$d047a7c56db64af4 = async function(url) {
    try {
        const res = await Promise.race([
            fetch(url),
            $d3824bf2ef2465db$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        if (!res.ok) throw new Error(res.status);
        const { status: status, data: data } = await res.json();
        if (status !== "success") throw new Error("Invalid id");
        return data;
    } catch (e) {
        throw e;
    }
};
const $d3824bf2ef2465db$export$39e0fd3547bcb345 = async function(url, uploadData) {
    try {
        const fetchPro = fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        });
        const res = await Promise.race([
            fetchPro,
            $d3824bf2ef2465db$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        const resData = await res.json();
        if (!res.ok) throw new Error(`${res.status} - ${resData.message || "Bad Request"}`);
        return resData;
    } catch (e) {
        throw e;
    }
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: []
    },
    bookmarks: []
};
const $0f1d4402dffacf5b$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f1d4402dffacf5b$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $d3824bf2ef2465db$export$d047a7c56db64af4)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/${id}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data);
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.some((b)=>b.id === id)) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
    } catch (e) {
        throw e;
    }
};
const $0f1d4402dffacf5b$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $d3824bf2ef2465db$export$d047a7c56db64af4)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = data.recipes.map((r)=>{
            return {
                id: r.id,
                title: r.title,
                publisher: r.publisher,
                image: r.image_url
            };
        });
        return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results;
    } catch (e) {
        // console.log(e);
        throw e;
    }
};
const $0f1d4402dffacf5b$var$persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
const $0f1d4402dffacf5b$export$72009cc673d27d80 = function(recipe) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(recipe);
    if (recipe.id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$export$136048bcb9946c75 = function(id) {
    const index = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage); // Assuming model.bookmarks exists
};
$0f1d4402dffacf5b$var$init();
const $0f1d4402dffacf5b$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ing)=>{
            const ingArr = ing[1].replaceAll(" ", "").split(",");
            if (ingArr.length !== 3) throw new Error("Wrong Ingredient Format! Please use the correct format..");
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $d3824bf2ef2465db$export$39e0fd3547bcb345)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/?key=${(0, $ba30e20475feac5a$export$7167c830cefcb6b5)}`, recipe);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(data.data);
        $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (e) {
        throw e;
    }
};


class $5d1bb7e064b2cbd1$var$BookmarkView {
    #data;
    #parentElement = document.querySelector(".header__bookmark-items__lists");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    #generateMarkup() {
        return `
            
         ${this.#data.map((bookmark)=>`
            <a href='#${bookmark.id}'>
            <li>
            <div><img src="${bookmark.image}"></div>
            <p>${bookmark.title}</p>
            </li>
            </a>
            `).join("")}   
        `;
    }
    render(data) {
        this.#parentElement.innerHTML = "";
        this.#data = data;
        const markup = this.#generateMarkup();
        this.#parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}
var $5d1bb7e064b2cbd1$export$2e2bcd8739ae039 = new $5d1bb7e064b2cbd1$var$BookmarkView();


class $d14dc0f178617192$var$RecipeView {
    #parentElement = document.querySelector(".container");
    #data;
    render(data) {
        this.#data = data;
        const markup = this.#generateMarkup();
        this.#parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    addHandlerRender(handler) {
        window.addEventListener("hashchange", handler);
    }
    renderLoader() {
        const markup = `
    <div class="spinner-div">
        <span class="spinner-div__loader"></span>
    </div>
    `;
        this.#parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    removeLoader() {
        const loader = document.querySelector(".spinner-div");
        if (loader) loader.remove();
    }
    renderError(message) {
        const markup = `
      <div class="error">
        <p class="error__message">${message}</p>
      </div>
`;
        this.#parentElement.insertAdjacentHTML("afterend", markup);
    }
    addHandlerAddBookmark(handler) {
        this.#parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".recipe-details__bookmark");
            if (!btn) return;
            handler();
        });
    }
    update(data) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this.#data = data;
        const newMarkup = this.#generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this.#parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            if (!newEl.isEqualNode(curEl) && newEl.firstChild.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    #generateMarkup() {
        return `
        <div class="recipe-details">
          <div class="recipe-details__overlay"></div>
          <div class="recipe-details__modal">
            <div class="recipe-details__img">
              <img
                class="recipe-details__img-element"
                src=${this.#data.image}
                alt="Recipe Image"
              />
            </div>
            
            <div class="recipe-details__name">
              <h1>${this.#data.title}</h1>
              <p>${this.#data.publisher}</p>
            </div>

            <div class="recipe-details__info">
              <span class="recipe-details__time">${this.#data.cookingTime} Minutes</span>
              <span class="recipe-details__servings">${this.#data.servings} Servings</span>
              <button class="recipe-details__bookmark">${this.#data.bookmarked ? "Bookmarked" : "Bookmark"}</button>
            </div>

            <div class="recipe-details__ingredients">
              <h2>Ingredients</h2>
              <ul class="recipe-details__ingredients-list">
              ${this.#data.ingredients.map((ing)=>this.#generateMarkupIngredient(ing)).join("")}
              </ul>
            </div>
          </div>
        </div>
      `;
    }
    #generateMarkupIngredient(ing) {
        return `
        <li class="recipe-details__ingredient-item">
         ${ing.quantity ? `${ing.quantity}:` : ""} ${ing.description}
        </li>
    `;
    }
}
var $d14dc0f178617192$export$2e2bcd8739ae039 = new $d14dc0f178617192$var$RecipeView();


class $813cf99795e9ec97$var$SearchView {
    #parentElement = document.querySelector(".recipe-container");
    #data;
    render(data) {
        this.#data = data;
        const markup = this.#generateMarkup();
        this.#parentElement.innerHTML = "";
        this.#parentElement.insertAdjacentHTML("beforeend", markup);
    }
    #generateMarkup() {
        return `
<div class="recipe-items">
${this.#data.map((item)=>`
    <a href='#${item.id}' >
    <div class="recipe-items__card">
    <div class="recipe-items__card-img">
    <img
    class="recipe-items__img"
    src=${item.image}
    alt="Pizza image"
    />
    </div>
    <div class="recipe-items__card-info">
    <h3 class="recipe-items__foodname">${item.title}</h3>
    <p class="recipe-items__description">${item.publisher}</p>
    </div>
    </div>
    </a >
    `).join("")}
</div>
`;
    }
}
var $813cf99795e9ec97$export$2e2bcd8739ae039 = new $813cf99795e9ec97$var$SearchView();


class $e5dc5dc5ede8bdf4$var$AddRecipeView {
    #parentElement = document.querySelector(".add-recipe__form");
    addRecipeForm = document.querySelector(".add-recipe__form");
    addRecipeBtn = document.querySelector(".add-recipe__icon");
    constructor(){
        this.addRecipeBtn.addEventListener("click", this.toggleForm.bind(this));
    }
    toggleForm() {
        this.addRecipeForm.classList.toggle("open");
    }
    closeForm() {
        this.addRecipeForm.classList.remove("open");
    }
    addHandlerUpload(handler) {
        this.#parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
}
var $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039 = new $e5dc5dc5ede8bdf4$var$AddRecipeView();


const $f50bd1f2915ed0f2$var$bookmarks = document.querySelector(".header__bookmark-title");
const $f50bd1f2915ed0f2$var$bookmarkList = document.querySelector(".header__bookmark-items");
const $f50bd1f2915ed0f2$var$searchForm = document.querySelector(".header__search");
const $f50bd1f2915ed0f2$var$searchInput = document.querySelector(".header__search-bar");
$f50bd1f2915ed0f2$var$searchForm.addEventListener("submit", (e)=>{
    e.preventDefault();
    const inputValue = $f50bd1f2915ed0f2$var$searchInput.value;
    if (inputValue.length < 2) return;
    $f50bd1f2915ed0f2$var$searchInput.blur();
    $f50bd1f2915ed0f2$var$controlSearchResults(inputValue);
});
$f50bd1f2915ed0f2$var$bookmarks.addEventListener("click", ()=>{
    $f50bd1f2915ed0f2$var$bookmarkList.classList.toggle("open");
});
const $f50bd1f2915ed0f2$var$controlSearchResults = async (query)=>{
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderLoader();
    try {
        const recipe = await $0f1d4402dffacf5b$export$202b8e5cb363a0c4(query);
        if (!recipe.length) throw new Error("Invalid search query");
        (0, $813cf99795e9ec97$export$2e2bcd8739ae039).render(recipe);
    } catch (e) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError(e);
    } finally{
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).removeLoader();
    }
};
async function $f50bd1f2915ed0f2$var$getRecipeController() {
    try {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderLoader();
        const id = window.location.hash.slice(1);
        await $0f1d4402dffacf5b$export$b96725c7a035d60b(id);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        const recipeDetail = document.querySelector(".recipe-details");
        const overlay = document.querySelector(".recipe-details__overlay");
        overlay.addEventListener("click", ()=>{
            recipeDetail.remove();
            history.pushState("", document.title, window.location.pathname);
        });
    } catch (e) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError(e);
    } finally{
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).removeLoader();
    }
}
(0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$getRecipeController);
const $f50bd1f2915ed0f2$var$controlBookmark = function() {
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlAddBookmark = function() {
    if (!$0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked) $0f1d4402dffacf5b$export$72009cc673d27d80($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    else $0f1d4402dffacf5b$export$136048bcb9946c75($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id);
    (0, $d14dc0f178617192$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlAddRecipe = async function(newRecipe) {
    try {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderLoader();
        await $0f1d4402dffacf5b$export$d660c2254e74960d(newRecipe);
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        const recipeDetail = document.querySelector(".recipe-details");
        const overlay = document.querySelector(".recipe-details__overlay");
        overlay.addEventListener("click", ()=>{
            recipeDetail.remove();
            history.pushState("", document.title, window.location.pathname);
        });
        setTimeout(function() {
            (0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).closeForm();
        }, 2000);
    } catch (e) {
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).renderError(e);
    } finally{
        (0, $d14dc0f178617192$export$2e2bcd8739ae039).removeLoader();
    }
};
(0, $d14dc0f178617192$export$2e2bcd8739ae039).addHandlerAddBookmark($f50bd1f2915ed0f2$var$controlAddBookmark);
(0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlBookmark);
(0, $e5dc5dc5ede8bdf4$export$2e2bcd8739ae039).addHandlerUpload($f50bd1f2915ed0f2$var$controlAddRecipe);


//# sourceMappingURL=index.7459d71b.js.map
